import React, { useMemo, useRef, useState } from 'react';

import { TextField, Typography } from '@mui/material';
import { get } from 'lodash';
import { MUIFieldProps } from '../../../../../lib/types/types';
import { MAX_TEXTBOX_LENGTH } from '../../../../../lib/constants/constant';
import { Help } from '@mui/icons-material';
import MUIToolTip from '../../../mui-tooltip/MUIToolTip';
import { set } from 'lodash';

const MUITextAreaField: React.FC<MUIFieldProps> = (props) => {
	const { label, tooltip, fieldValue, updateFieldValue, isDisabled, error, errorMessage, ...restProps } = props;

	const [inputValue, setInputValue] = useState(fieldValue);

	useMemo(() => {
		setInputValue(fieldValue);
	}, [fieldValue]);

	const maxAllowCharacterLength = get(props, 'maxCharLength', MAX_TEXTBOX_LENGTH);

	const timeoutRef: { current: NodeJS.Timeout | null } = useRef(null);

	const debouncedOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		// Clear timeout if there was one pending
		if (timeoutRef.current) {
			clearTimeout(timeoutRef.current);
		}
		let inputValue = e.target.value ? e.target.value : '';
		let strapiValue = inputValue;

		if (get(props, 'maxCharLength') || maxAllowCharacterLength) {
			if (strapiValue.length > maxAllowCharacterLength) {
				strapiValue = strapiValue.slice(0, maxAllowCharacterLength);
			}
		}
		set(e, 'target.value', strapiValue);
		setInputValue(strapiValue);
		
		// Schedule `onChange` call and store timeout id in the ref
		timeoutRef.current = setTimeout(() => {
			let event = { target: { value: get(e, 'target.value', '') } };
			updateFieldValue(event as React.ChangeEvent<HTMLInputElement>);
		}, 10);
	};
	return (
		<>
			<TextField
				multiline
				id="demo-helper-text-aligned"
				label={
					tooltip ? (
						<>
							<>{label}</>
							<MUIToolTip title={tooltip}>
								{' '}
								<Help fontSize="small" color="primary" sx={{ ml: '5px' }} />{' '}
							</MUIToolTip>
						</>
					) : (
						<>{label}</>
					)
				}
				value={inputValue}
				onChange={debouncedOnChange}
				disabled={isDisabled}
				error={error}
				helperText={errorMessage}
				minRows={get(props, 'row', 4)}
				maxRows={get(props, 'row', 6)}
				fullWidth
				{...restProps}
			/>
			<Typography variant="caption">
				{inputValue.length + ' / ' + maxAllowCharacterLength + ' Zeichen (inkl. Leerzeichen) verwendet'}
			</Typography>
		</>
	);
};

export default MUITextAreaField;
